import { Vue, Component, Prop, Mixins } from "vue-property-decorator";
//import iconCarret from "~/assets/inline-svg/icon_carret.svg";
import Dropdown from "./dropdown";
import RightsAware from '@/lib/mixins/rights-aware';
import Icon from './icon';
import { strCompare } from '@/lib/helpers';
import { Placement } from "popper.js";

@Component
class ListDropdown extends Mixins(RightsAware) {

  @Prop({default: false}) readonly openOnInit!: boolean;
  @Prop({default: "bottom-start", type: String}) readonly placement!: Placement;
  @Prop({default: ""}) readonly layerClassNames!: string;
  @Prop({default: false}) readonly closeOnClickLayer!: boolean;
  @Prop({type: [Object, String, Number]}) readonly value!: any;
  @Prop() readonly data!: any[];
  @Prop({default: "sélectionner"}) readonly prompt!: string;
  @Prop({default: false}) readonly stopTriggerPropagation!: boolean;
  @Prop({default: v => v.label, type: Function}) readonly labelFn!: Function;
  @Prop({default: v => v, type: Function}) readonly transform!: Function;
  @Prop({default: true, type: Boolean}) readonly nullable!: boolean;

  created() {}

  eqFn(value, row) {
    return (value != null && row && value == this.transform(row))
      || (value != null && typeof value === "object" && value.equals && value.equals(this.transform(row)))
      || (value != null && typeof value === "object" && row && value.id && value.id === this.transform(row).id);
  }

  get selectedRow() {
    return this.value != null && this.data && this.data.find(v => this.eqFn(this.value, v));
  }

  get sortedData() {
    return this.data && [...this.data].sort((a, b) => strCompare(this.labelFn(a), this.labelFn(b)));
  }

  onSelect(row) {
    this.$emit("input", row && this.transform(row));
    this.$emit("change", row);
  }

  getRowLabel(row) {
    return (row && this.labelFn(row)) || this.prompt;
  }

  render() {
    return (
      <Dropdown class="list-dropdown" placement={this.placement} stopTriggerPropagation={this.stopTriggerPropagation} closeOnClickLayer={true}
        scopedSlots={{
          trigger: () => <a class="action">
            <span class="trigger-label">{this.getRowLabel(this.selectedRow)}</span>
            {!this.isReadonly && [
              this.nullable && this.value != null ? (
                <div class="icon has-text-danger"
                  onClick={e => (this.onSelect(null), e.stopImmediatePropagation())}>
                  <Icon icon="delete" class="icon grey-light"/>
                </div>
               ) : null,
               <Icon icon="caret-down" class="icon caret-icon grey"/>
            ].filter(Boolean)}
          </a>,
          layer: () => (
            <div class="list-dropdown__layer">
              <ul>
                {this.sortedData && this.sortedData.map(v => (
                  <li class={`dd-option ${this.eqFn(this.value, v) ? 'selected' : ''}`}
                    onClick={() => this.onSelect(v)}>{this.getRowLabel(v)}</li>
                ))}
              </ul>
            </div>
          )
        }}
      />
    );
  }
}

export default ListDropdown;

// VUE JSX HOT LOADER //
if (module.hot) require("/Users/home/j2ee/projects/cavites/src/main/client/node_modules/vue-jsx-hot-loader/src/api.js")({ Vue: require('vue'), ctx: eval('this'), module: module, hotId: "_vue_jsx_hot-f844061c/list-dropdown.tsx" });